<template>
  <ResumeSection
      :title="$tResumePage('Uploaded documents')"
      :isOpen="isOpenOnMobile"
      :toggle="!isToggleHidden"
  >
    <template v-slot:icon>
      <BaseSvg name="ico-passport-card" width="3.3rem" height="2.4rem"/>
    </template>
    <template v-slot:default>
      <div class="resume-downloaded-documents">
        <div v-for="(doc, index) in documents"
             :key="index"
             :class="{'_open' : isSectionShow(index)}"
             class="resume-downloaded-documents__accordion-item">
          <div @click.prevent="onToggle(index)"
               class="resume-downloaded-documents__accordion-head">
            <transition name="fade"></transition>
            <h3 class="resume-downloaded-documents__accordion-name">
              {{ $tResumePage('INTERNATIONAL PASSPORT') }} {{ index + 1 }}
            </h3>
            <div class="resume-downloaded-documents__accordion-btn">
              <span v-if="isSectionShow(index)">{{ $tResumePage('Hide reversals') }}</span>
              <span v-else>{{ $tResumePage('Show reversals') }}</span>
              <div class="resume-downloaded-documents__accordion-btn-ico">
                <BaseSvg name="ico-arrow-down-2"/>
              </div>
            </div>
          </div>
          <ResumeDownloadedDocumentsGroup :showFiles="isSectionShow(index)"
                                          :documents="doc.items"
                                          :viewedPassportPages="viewedPassportPages"
                                          :archiveNames="archiveNames"
                                          :selectedDocumentsIds="selectedDocumentsIds"
                                          :mainInfo="mainInfo"
                                          @toggle-select="onToggleSelect"/>
        </div>

        <div class="resume-downloaded-documents__accordion-actions">
          <button v-if="selectedDocumentsIds.length"
                  type="button"
                  @click.prevent="downloadSelected"
                  class="base-btn base-btn--outline-grey--blue  base-btn--small">
            <span class="base-btn__text">{{ $tResumePage('Download selected') }}</span>
            <BasePreloader v-if="pendingSelected"/>
          </button>
          <button v-else
                  type="button"
                  disabled
                  class="base-btn base-btn--outline-grey--blue  base-btn--small">
            <span class="base-btn__text">{{ $tResumePage('Download selected') }}</span>
          </button>
          <button type="button"
                  @click.prevent="downloadAll"
                  class="base-btn base-btn--outline-grey--blue  base-btn--small">
            <span class="base-btn__text">{{ $tResumePage('Download by one archive') }}</span>
            <BasePreloader v-if="pendingAll"/>
          </button>
        </div>
      </div>
    </template>
  </ResumeSection>
</template>

<script>
  import ResumeSection from './ResumeSection'
  import ResumeDownloadedDocumentsGroup from './ResumeDownloadedDocumentsGroup'
  import download from '@/helpers/download'

  export default {
    name: "ResumeDownloadedDocuments",
    components: {
      ResumeSection,
      ResumeDownloadedDocumentsGroup,
    },
    props: {
      documents: Array,
      viewedPassportPages: Array,
      isOpenOnMobile: Boolean,
      archiveNames: Object,
      isToggleHidden: Boolean,
      resumeId: Number,
      mainInfo: Object,
    },
    data() {
      return {
        durationShow: 600,
        durationHide: 400,

        pendingSelected: false,
        pendingAll: false,
        showSections: [],
        selectedDocumentsIds: []
      };
    },
    computed: {},
    methods: {
      isSectionShow(index) {
        return this.showSections.includes(index)
      },
      onToggle(index) {
        if (this.isSectionShow(index)) {
          this.showSections = this.showSections.filter(i => i !== index)
        } else {
          this.showSections.push(index)
        }
      },
      onToggleSelect(id) {
        if (this.selectedDocumentsIds.includes(id)) {
          this.selectedDocumentsIds = this.selectedDocumentsIds.filter(i => i !== id)
        } else {
          this.selectedDocumentsIds.push(id)
        }
      },
      getDelay() {
        return 0;
      },
      afterLeave() {
        console.log('afterLeave')
      },
      downloadSelected() {
        this.pendingSelected = true

        if (!this.selectedDocumentsIds.length) return

        this.downloadSpecified(this.selectedDocumentsIds)
            .finally(() => {
              this.pendingSelected = false
            })

        this.selectedDocumentsIds = []
      },

      downloadAll() {
        this.pendingAll = true

        const ids = this.documents.reduce((result, document) => {
          document.items.forEach(item => {
            result.push(item.passport_page.section_id)
          })

          return result
        }, [])

        this.downloadSpecified(ids)
            .finally(() => {
              this.pendingAll = false
            })
      },

      downloadSpecified(ids) {
        if (!ids.length) return Promise.reject()

        const params = ids
            .map((id) => `passports[]=${id}`)
            .join('&');

        return download(
            `api/new-resume/get-passport-list-archive/${this.resumeId}?${params}`,
            this.archiveNames.passport,
            null,
            true,
            'application/zip'
        );
      },
    }
  };
</script>
